import { OracleIconUrl } from "@p0security/shared/integrations/constants";
import { OracleComponents } from "@p0security/shared/integrations/resources/oracle/components";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { oracleInstaller } from "./install/install";

export const Oracle = (
  props: Pick<
    InstallProps<typeof OracleComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "domain", []);

  return (
    <Install<typeof OracleComponents>
      components={OracleComponents}
      installer={oracleInstaller()}
      integration="oci"
      itemKind={itemKind}
      logo={OracleIconUrl}
      title={"Oracle Cloud"}
      {...props}
    />
  );
};
